import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ABTestexperimentProps } from './types';

const initialState: Partial<ABTestexperimentProps> = {
  details: '',
  value: undefined,
  variation: '',
};

export const abTestingSlice = createSlice({
  name: 'ABTesting',
  initialState,
  reducers: {
    setABTestExperiment: (state, action: PayloadAction<ABTestexperimentProps | null>) => {
      if (action.payload) {
        state = Object.assign(state, action.payload);
      }
    },
  },
});

export const { setABTestExperiment } = abTestingSlice.actions;

export default abTestingSlice.reducer;
